import type { TInstituteStatus } from "../../../apis/institute/institute.interfaces";

export function formatInstituteStatusLabel(status: TInstituteStatus): string {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

export function instituteStatusChipColor(
  status: TInstituteStatus,
): "success" | "warning" | "error" | "default" | "info" {
  switch (status) {
    case "active":
      return "success";
    case "pending":
      return "warning";
    case "draft":
      return "info";
    case "archived":
      return "default";
    case "other":
    default:
      return "default";
  }
}
